"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApButtonFilter = exports.ApButtonTab = exports.ApButtonIcon = exports.ApButtonText = exports.ApButtonLink = exports.ApButtonDanger = exports.ApButtonSecondary = exports.ApButtonOrange = exports.ApButtonMain = void 0;
var React = require("react");
var styles_1 = require("./styles");
var theme_1 = require("../../utils/theme");
var types_1 = require("../../utils/types");
var ApIcon_1 = require("../ApIcon");
var DEFAULT_ICON_SIZE = '18px';
exports.ApButtonMain = React.forwardRef(function (_a, ref) {
    var children = _a.children, iconName = _a.iconName, iconProps = _a.iconProps, className = _a.className, theme = _a.theme, props = __rest(_a, ["children", "iconName", "iconProps", "className", "theme"]);
    return (React.createElement(styles_1.StyledButtonMain, __assign({}, props, { iconName: iconName, tabIndex: 0, theme: theme, className: "ap-button-main " + (className ? className : ''), ref: ref }), iconName
        ? React.createElement(React.Fragment, null,
            React.createElement(styles_1.StyledButtonLeftChild, null,
                React.createElement(ApIcon_1.ApIcon, __assign({ iconName: iconName, iconSize: DEFAULT_ICON_SIZE }, iconProps))),
            React.createElement(styles_1.StyledButtonRightChild, null, children))
        : React.createElement(styles_1.StyledButtonChild, null, children)));
});
exports.ApButtonOrange = React.forwardRef(function (_a, ref) {
    var children = _a.children, iconName = _a.iconName, iconProps = _a.iconProps, className = _a.className, theme = _a.theme, props = __rest(_a, ["children", "iconName", "iconProps", "className", "theme"]);
    return (React.createElement(styles_1.StyledButtonOrange, __assign({}, props, { iconName: iconName, tabIndex: 0, theme: theme, className: "ap-button-orange " + (className ? className : ''), ref: ref }), iconName
        ? React.createElement(React.Fragment, null,
            React.createElement(styles_1.StyledButtonLeftChild, null,
                React.createElement(ApIcon_1.ApIcon, __assign({ iconName: iconName, iconSize: DEFAULT_ICON_SIZE }, iconProps))),
            React.createElement(styles_1.StyledButtonRightChild, null, children))
        : React.createElement(styles_1.StyledButtonChild, null, children)));
});
exports.ApButtonSecondary = React.forwardRef(function (_a, ref) {
    var children = _a.children, iconName = _a.iconName, iconProps = _a.iconProps, className = _a.className, theme = _a.theme, props = __rest(_a, ["children", "iconName", "iconProps", "className", "theme"]);
    return (React.createElement(styles_1.StyledButtonSecondary, __assign({}, props, { iconName: iconName, theme: theme, tabIndex: 0, className: "ap-button-secondary " + (className ? className : ''), ref: ref }), iconName
        ? React.createElement(React.Fragment, null,
            React.createElement(styles_1.StyledButtonLeftChild, null,
                React.createElement(ApIcon_1.ApIcon, __assign({ iconName: iconName, iconSize: DEFAULT_ICON_SIZE }, iconProps))),
            React.createElement(styles_1.StyledButtonRightChild, null, children))
        : React.createElement(styles_1.StyledButtonChild, null, children)));
});
exports.ApButtonDanger = React.forwardRef(function (_a, ref) {
    var children = _a.children, iconName = _a.iconName, iconProps = _a.iconProps, className = _a.className, theme = _a.theme, props = __rest(_a, ["children", "iconName", "iconProps", "className", "theme"]);
    return (React.createElement(styles_1.StyledButtonDanger, __assign({}, props, { iconName: iconName, tabIndex: 0, theme: theme, className: "ap-button-danger " + (className ? className : ''), ref: ref }), iconName
        ? React.createElement(React.Fragment, null,
            React.createElement(styles_1.StyledButtonLeftChild, null,
                React.createElement(ApIcon_1.ApIcon, __assign({ iconName: iconName, iconSize: DEFAULT_ICON_SIZE }, iconProps))),
            React.createElement(styles_1.StyledButtonRightChild, null, children))
        : React.createElement(styles_1.StyledButtonChild, null, children)));
});
exports.ApButtonLink = React.forwardRef(function (_a, ref) {
    var children = _a.children, left = _a.left, right = _a.right, className = _a.className, props = __rest(_a, ["children", "left", "right", "className"]);
    return (React.createElement(styles_1.StyledButtonLink, __assign({}, props, { tabIndex: 0, className: "ap-button-link " + (className ? className : ''), ref: ref }),
        left && React.createElement(styles_1.StyledButtonLeftChild, null, left()),
        right && React.createElement(styles_1.StyledButtonRightChild, null, right()),
        !left && !right && React.createElement(styles_1.StyledButtonChild, null, children)));
});
exports.ApButtonText = React.forwardRef(function (_a, ref) {
    var children = _a.children, left = _a.left, right = _a.right, className = _a.className, props = __rest(_a, ["children", "left", "right", "className"]);
    return (React.createElement(styles_1.StyledButtonText, __assign({}, props, { tabIndex: 0, className: "ap-button-text " + (className ? className : ''), ref: ref }),
        left && React.createElement(styles_1.StyledButtonLeftChild, null, left()),
        right && React.createElement(styles_1.StyledButtonRightChild, null, right()),
        !left && !right && React.createElement(styles_1.StyledButtonChild, null, children)));
});
exports.ApButtonIcon = React.forwardRef(function (_a, ref) {
    var iconName = _a.iconName, hoverColor = _a.hoverColor, className = _a.className, _b = _a.theme, theme = _b === void 0 ? types_1.LIGHT : _b, iconProps = _a.iconProps, props = __rest(_a, ["iconName", "hoverColor", "className", "theme", "iconProps"]);
    return (React.createElement(styles_1.StyledButtonIcon, __assign({}, props, { theme: theme, hoverColor: hoverColor, tabIndex: 0, className: "ap-button-icon " + (className ? className : ''), ref: ref }),
        React.createElement(ApIcon_1.ApIcon, __assign({ iconName: iconName }, iconProps))));
});
exports.ApButtonTab = React.forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, isSelected = _a.isSelected, theme = _a.theme, icon = _a.icon, props = __rest(_a, ["children", "className", "isSelected", "theme", "icon"]);
    return (React.createElement(styles_1.StyledButtonTab, __assign({}, props, { icon: icon, theme: theme, isSelected: isSelected, tabIndex: 0, className: "ap-button-tab " + (className ? className : ''), ref: ref }),
        React.createElement(styles_1.StyledButtonTabText, null, children),
        icon && (React.createElement(styles_1.StyledButtonTabIcon, { iconName: icon }))));
});
exports.ApButtonFilter = React.forwardRef(function (_a, ref) {
    var children = _a.children, left = _a.left, right = _a.right, className = _a.className, isSelected = _a.isSelected, props = __rest(_a, ["children", "left", "right", "className", "isSelected"]);
    return (React.createElement(styles_1.StyledButtonFilter, __assign({}, props, { isSelected: isSelected, tabIndex: 0, className: "ap-button-filter " + (className ? className : ''), ref: ref }),
        left && React.createElement(styles_1.StyledButtonLeftChild, null, left()),
        right && React.createElement(styles_1.StyledButtonRightChild, null, right()),
        !left && !right && React.createElement(styles_1.StyledButtonChild, null, children)));
});
exports.ApButtonMain.defaultProps = {
    autoFocus: false,
    disabled: false,
    theme: types_1.LIGHT,
    small: false
};
exports.ApButtonOrange.defaultProps = {
    autoFocus: false,
    disabled: false,
    theme: types_1.LIGHT,
    small: false
};
exports.ApButtonSecondary.defaultProps = {
    autoFocus: false,
    disabled: false,
    theme: types_1.LIGHT,
    small: false
};
exports.ApButtonDanger.defaultProps = {
    autoFocus: false,
    disabled: false,
    theme: types_1.LIGHT,
    small: false
};
exports.ApButtonIcon.defaultProps = {
    autoFocus: false,
    disabled: false,
    hoverColor: theme_1.colors.green1,
    theme: types_1.LIGHT,
    small: false
};
exports.ApButtonTab.defaultProps = {
    autoFocus: false,
    disabled: false,
    theme: types_1.LIGHT,
    small: false
};
exports.ApButtonFilter.defaultProps = {
    autoFocus: false,
    disabled: false,
    small: false
};
//# sourceMappingURL=ApButtons.js.map